/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import { getBizID, getServices } from "../../libs/todoSlice"
import { useEffect } from "react"
import { getSharedTokenRedux, setSharedTokenRedux } from "../../libs/digitalWorkFlowSlice"
import axios from "axios"
import LoadingComponent from "../../lib/LoadingComponent"

const IDConnect = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const services = useSelector(getServices)
  const params = useParams()
  const businessID = useSelector(getBizID)
  useEffect(() => {
    if (!services.includes('id-connect')) {
      navigate(`/${params.prefix}/manage-members`)
    } else {
      getSharedToken()
    }
  }, [services])

  const sharedToken = useSelector(getSharedTokenRedux)
  const setSharedToken = (action) => {
    dispatch(setSharedTokenRedux({
      sharedToken: action
    }))
  }
  const getSharedToken = async () => {
    try {
      const { data } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/shared-token`
      })
      setSharedToken(data.data.shared_token)
    } catch ({ response }) {
      const { status } = response
      if (status === 401) {
        navigate(`/${params.prefix}`)
      }
    }
  }
  useEffect(() => {
    if (sharedToken) {
      window.open(`${process.env.REACT_APP_ID_CONNECT_URL}/login/bypass?sharetoken=${sharedToken}&biz_id=${businessID}`,'_blank')
    }
  }, [sharedToken]
  );
  return <LoadingComponent width={150} height={150} />
}

export default IDConnect